import type {
	InsuredPersonDTO,
	InsuredPersonRiskDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseThousands } from "web_myplann/Shared/Utils/numberFormatters";

export type InsuredPersonRiskWithValue = {
	risk: InsuredPersonRiskDTO;
	value: number;
};

export type InsuredPersonWithRisks = {
	person: InsuredPersonDTO;
	risks: InsuredPersonRiskWithValue[];
};

export const insuredPersonsWithRisks = (
	insuredPersons: InsuredPersonDTO[] | null | undefined,
): InsuredPersonWithRisks[] =>
	(insuredPersons ?? [])
		.map((person) => ({
			person,
			risks: (person.risks ?? []).reduce<InsuredPersonRiskWithValue[]>(
				(accumulator, risk) => {
					const value = parseThousands(risk.value ?? "");

					if (value !== undefined) {
						accumulator.push({ risk, value });
					}

					return accumulator;
				},
				[],
			),
		}))
		.filter(({ risks }) => risks.length > 0);
